import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["value", "render", "data", "onChange", "cancelable", "separator"];
import PropTypes from 'prop-types';
import React from 'react';
import ErrorBoundary from '../ErrorBoundary';
import BasicRadioGroup from '../BasicRadioGroup';
export default function RadioGroup(_ref) {
  var _data$;

  var value = _ref.value,
      render = _ref.render,
      data = _ref.data,
      onChange = _ref.onChange,
      cancelable = _ref.cancelable,
      separator = _ref.separator,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(ErrorBoundary, null, render({
    data: data,
    isChecked: function isChecked(v) {
      return v === value;
    },
    withLabel: data === null || data === void 0 ? void 0 : (_data$ = data[0]) === null || _data$ === void 0 ? void 0 : _data$.data,
    select: function select(v) {
      if (v !== value) {
        onChange(v);
      } else if (v === value && cancelable) {
        onChange(null);
      }
    }
  }, otherProps));
}
RadioGroup.propTypes = {
  value: PropTypes.any,
  render: PropTypes.func,
  data: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
  onChange: PropTypes.func,
  cancelable: PropTypes.bool,
  className: PropTypes.string,
  size: PropTypes.oneOf(['large', 'middle', 'small', 'mini']),
  separator: PropTypes.bool
};
RadioGroup.defaultProps = {
  render: BasicRadioGroup,
  value: null,
  onChange: function onChange() {},
  cancelable: false,
  className: '',
  size: null,
  separator: null
};